import { createSlice } from "@reduxjs/toolkit";
import anhCategory from "../../assets/anhCategory.jpg";
const fakeData = [
  {
    id: 1,
    title: "Hoạt động hội viên hiệp hội nổi bật",
    image: anhCategory,
    gradient: "from-orange-500",
  },
  {
    id: 2,
    title: "Thăm doanh nghiệp",
    image: anhCategory,
    gradient: "from-blue-500",
  },
  {
    id: 3,
    title: "Công tác trách nhiệm xã hội",
    image: anhCategory,
    gradient: "from-red-500",
  },
  {
    id: 4,
    title: "Đại hội & Hội nghị",
    image: anhCategory,
    gradient: "from-green-500",
  },
];

const categorySlice = createSlice({
  name: "category",
  initialState: {
    items: fakeData,
  },
  reducers: {
    addItem: (state, action) => {
      state.items.push(action.payload);
    },
    removeItem: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
});

export const { addItem, removeItem } = categorySlice.actions;
export default categorySlice.reducer;
